import {Platform, StyleSheet} from 'react-native';

import {TAB_BAR_HEIGH} from '/component/layout/TabLayout/TabLayout.style';
import {MAX_CONTENT_WIDTH} from '/constant/data.constant';
import {indent} from '/constant/layout.constant';
import {black, grayscale, greyf7, white} from '/theme/color/on.color';
import {alto, denim} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: white,
    overflow: 'hidden',
    overflowY: 'hidden',
    overflowX: 'hidden',
  } as any,

  webScrollContainer: {
    flex: 1,
    minHeight: 0,
    height: '100%',
    maxHeight: '100dvh',
    overflowY: 'scroll',
    overflowX: 'hidden',
    WebkitOverflowScrolling: 'touch',
    paddingBottom: TAB_BAR_HEIGH,
    overscrollBehavior: 'contain',
    width: '100%' as any,
    maxWidth: MAX_CONTENT_WIDTH as any,
    alignSelf: 'center' as any,
  } as any,

  loadingOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    zIndex: 99,
  },
  base: {
    backgroundColor: white,
    width: '100%',
  },
  scrollViewContainer: {
    maxHeight: 150,
    backgroundColor: white,
  },
  buttonWidth: {
    flex: 1,
    marginLeft: 0,
    ...(Platform.OS === 'web' && {cursor: 'pointer'}),
  },
  buttonFilter: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    height: 36,
    backgroundColor: white,
    borderWidth: 1,
    borderColor: alto,
    marginLeft: 10,
    paddingVertical: indent * 0.1,
    paddingHorizontal: indent * 0.8,
    borderRadius: indent * 0.4,
    ...(Platform.OS === 'web' && {cursor: 'pointer'}),
  },
  viewContainer: {
    flexDirection: 'row',
    paddingHorizontal: 16,
    backgroundColor: white,
  },
  filtersButtonContainer: {
    marginTop: 6,
    width: '100%',
  },
  SearchIcon: {
    fontSize: 22,
    color: grayscale,
  },
  iconReport: {
    fontSize: 16,
    width: 16,
    height: 16,
    paddingTop: 8,
  },
  text: {
    marginLeft: indent * 0.4,
    fontSize: 14,
    maxWidth: 150,
  },
  filterTextWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  filterDot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: white,
    marginLeft: 6,
    marginTop: 2,
  },
  buttonFilterActive: {
    backgroundColor: denim,
  },
  iconActive: {
    color: white,
  },
  textActive: {
    color: white,
  },
  tabBar: {
    flexDirection: 'row',
    backgroundColor: greyf7,
    borderRadius: 40,
    padding: 3,
    marginHorizontal: 16,
    marginTop: 0,
    marginBottom: 0,
    justifyContent: 'center',
  },
  tabItem: {
    flex: 1,
    alignItems: 'center',
    paddingVertical: 6,
    borderRadius: 40,
    backgroundColor: 'transparent',
    ...(Platform.OS === 'web' && {cursor: 'pointer'}),
  },
  tabText: {
    color: black,
    fontSize: 14,
  },
  activeTab: {
    backgroundColor: white,
    borderColor: alto,
    borderWidth: 1,
  },
  clearFilterRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 6,
    paddingHorizontal: 12,
  },
  clearFilterButton: {
    height: 36,
    borderWidth: 1,
    borderColor: alto,
    borderRadius: 8,
    justifyContent: 'center',
    backgroundColor: white,
    paddingHorizontal: 12,
    alignSelf: 'flex-end',
    ...(Platform.OS === 'web' && {cursor: 'pointer'}),
  },
  clearFilterText: {
    color: black,
    fontSize: 14,
    textAlign: 'center',
  },
  ReportTitle: {
    fontSize: 16,
    whiteSpace: 'nowrap',
  } as any,
});
